wbApp.controller('CourseTypesDetailCtrl', ['$scope', 'courseTypeSvc',
function ($scope, courseTypeSvc) {

    $scope.modelOrig = angular.copy($scope.model);

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.isSaving = false;

    $scope.onDetailSave = function (model) {

        $scope.isSaving = true;

        if (!model.courseTypeID) {
            courseTypeSvc.insert(model, success, error);
        } else {
            courseTypeSvc.update(model, success, error);
        }

        function success() {
            $scope.isSaving = false;
            $scope.$hide();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }
    }
}]);
